import React, { useEffect, useState } from 'react';
import { Texture } from 'pixi.js'
import { Sprite, Container, AnimatedSprite } from '@inlet/react-pixi'
import { ease } from 'pixi-ease'

import { GetExtraLevelAssetByTraitGroupId } from '../../../actions/home-actions'
import LearningDolphinAssetHolder from './ExtraMaxLevelAsset/LearningDolphinAssetHolder'

let heliTextures = [];

const LearningMaxLevel = ({ _xPos, _yPos, _traitGroupScore, _traitGroupId }) => {

    const [assetCount, setAssetCount] = useState({ ship: 0, dolphin: 0 });

    const boat1Sprite = React.useRef();
    const boat2Sprite = React.useRef();
    const heliSprite = React.useRef();
    const shipSprite = React.useRef();
    const ship2Sprite = React.useRef();
    const ship3Sprite = React.useRef();
    const warshipSprite = React.useRef();

    let _count = (_traitGroupScore - 100) / 20;

    let warshipTexture = Texture.from(`./assets/images/components/island/particle/maxLevel/learning/acc_green.png`);
    let jetTexture = Texture.from(`./assets/images/components/island/particle/maxLevel/learning/jet.png`);
    //heli
    for (let i = 1; i <= 5; i++) {
        let heliTexture = Texture.from(`./assets/images/components/island/particle/maxLevel/learning/heli/heli${i}.png`);
        heliTextures.push(heliTexture);
    }
    let boat1Texture = Texture.from(`./assets/images/components/island/particle/maxLevel/learning/bouy_green_01.png`);
    let boat2Texture = Texture.from(`./assets/images/components/island/particle/maxLevel/learning/patrolboat_green_01.png`);
    let shipTexture = Texture.from(`./assets/images/components/island/particle/maxLevel/learning/sailboat_green_01.png`);
    let ship2Texture = Texture.from(`./assets/images/components/island/particle/maxLevel/learning/tugboat_green_01.png`);
    let ship3Texture = Texture.from(`./assets/images/components/island/particle/maxLevel/learning/Yatch_Green_01.png`);

    useEffect(() => {
        const initExtraLevelAsset = async () => {
            let response = await GetExtraLevelAssetByTraitGroupId(_traitGroupId);
            //console.log("Extra Level Asset response:", response);
            let shipCount = 0;
            let dolphinCount = 0;
            if (response.data != null && response.data.length > 0) {
                //console.log("Extra Level Asset data:", response.data);
                response.data.forEach((item) => {
                    switch (item.seletctedItemName) {
                        case "Ship":
                            ++shipCount;
                            break;
                        case "Dolphin":
                            ++dolphinCount;
                            break;
                    }
                })

                setAssetCount({ ship: shipCount, dolphin: dolphinCount });
            }
        }
        initExtraLevelAsset();
    }, []);

    useEffect(() => {
        if (boat1Sprite.current !== null && boat1Sprite.current !== undefined) {
            ease.target(boat1Sprite.current, { x: -185, y: -35 }, 0.001, { repeat: true, reverse: true })
        }
        if (warshipSprite.current !== null && warshipSprite.current !== undefined) {
            ease.target(warshipSprite.current, { x: -5, y: 5 }, 0.001, { repeat: true, reverse: true })
        }
        if (boat2Sprite.current !== null && boat2Sprite.current !== undefined) {
            ease.target(boat2Sprite.current, { x: -225, y: -25 }, 0.001, { repeat: true, reverse: true })
        }
        if (shipSprite.current !== null && shipSprite.current !== undefined) {
            ease.target(shipSprite.current, { x: 0, y: 200 }, 0.001, { repeat: true, reverse: true })
        }
        if (ship2Sprite.current !== null && ship2Sprite.current !== undefined) {
            ease.target(ship2Sprite.current, { x: -105, y: 115 }, 0.001, { repeat: true, reverse: true })
        }
        if (ship3Sprite.current !== null && ship3Sprite.current !== undefined) {
            ease.target(ship3Sprite.current, { x: 175, y: 115 }, 0.001, { repeat: true, reverse: true })
        }
        if (heliSprite.current !== null && heliSprite.current !== undefined) {
            ease.target(heliSprite.current, { x: 100, y: 80 }, 0.001, { repeat: true, reverse: true })
        }
    }, [assetCount]);

    return (
        <Container x={_xPos} y={_yPos}>
            {
                assetCount.ship > 0 ?
                    <Sprite x={-180} y={-30} ref={boat1Sprite}
                        texture={boat1Texture}
                        scale={{ x: 0.08, y: 0.08 }}
                    />
                    : <></>

            }
            {
                assetCount.ship > 1 ?
                    <Sprite x={-230} y={-30} ref={boat2Sprite}
                        texture={boat2Texture}
                        scale={{ x: 0.25, y: 0.25 }}
                    />
                    : <></>
            }
            {
                assetCount.ship > 2 ?
                    <>
                        <Sprite ref={warshipSprite}
                            texture={warshipTexture}
                            scale={{ x: 0.3, y: 0.3 }}
                        />
                        <AnimatedSprite ref={heliSprite}
                            textures={heliTextures}
                            isPlaying={true}
                            initialFrame={0}
                            scale={{ x: 0.3, y: 0.3 }}
                            animationSpeed={0.1}
                        />
                    </>
                    : <></>
            }
            {
                assetCount.ship > 3 ?
                    <Sprite ref={shipSprite}
                        x={30} y={110}
                        texture={shipTexture}
                        scale={{ x: 0.2, y: 0.2 }}
                    />
                    : <></>
            }
            {
                assetCount.ship > 4 ?
                    <Sprite ref={ship2Sprite}
                        x={170} y={110}
                        texture={ship3Texture}
                        scale={{ x: 0.15, y: 0.15 }}
                    />
                    : <></>
            }
            {
                assetCount.ship > 5 ?
                    <Sprite ref={ship3Sprite}
                        x={-100} y={110}
                        texture={ship2Texture}
                        scale={{ x: 0.15, y: 0.15 }}
                    />
                    : <></>
            }
            <LearningDolphinAssetHolder _count={assetCount.dolphin} />
        </Container>
    );
};

export { LearningMaxLevel as default }